// src/client.js
import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

// Initialize the Sanity client
export const client = sanityClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: 'production',
  apiVersion: '2025-02-05',
  useCdn: true,
  token: process.env.REACT_APP_SANITY_TOKEN,
});

// Set up the image URL builder
const builder = imageUrlBuilder(client);

// Helper to get an image URL string (without needing .url())
export const urlFor = (source) => {
  if (!source) return null;
  return builder.image(source).url();  // This returns a URL directly
};